import { Button, Group, TextInput, Text, Box } from '@mantine/core';

import { useKeywordRuleForm } from '../../../hooks/useKeywordRuleForm';
import { prophetTypes } from '../../../types';
import { ChunkPlatform } from '../../../utils/chunk-limits';

import { Messages } from './Messages';

type Props = {
  onSubmit: (data: Omit<Parameters<prophetTypes.AddKeywordRule>[0], 'page'>) => void;
  isLoading: boolean;
  initialValues?: Pick<prophetTypes.KeywordRule, 'messages' | 'keyword'>;
  platform: ChunkPlatform;
};

export const KeywordRuleForm = ({ onSubmit, isLoading, initialValues, platform }: Props) => {
  const form = useKeywordRuleForm({ initialValues, platform });

  const isFormError = Object.keys(form.errors).length > 0;

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <TextInput
        disabled={!!initialValues}
        label="Кодовое слово"
        placeholder="Кодовое слово"
        value={form.values.keyword}
        onChange={(event) => form.setFieldValue('keyword', event.currentTarget.value)}
        my="sm"
        error={form.errors.keyword}
      />
      <Messages form={form} platform={platform} />
      <Box h={25}>
        {isFormError && (
          <Text c="red" size="sm" ta="end">
            {Object.values(form.errors)[0] || 'Ошибка'}
          </Text>
        )}
      </Box>
      <Group justify="flex-end">
        <Button loading={isLoading} type="submit">
          {initialValues ? 'Сохранить' : 'Создать'}
        </Button>
      </Group>
    </form>
  );
};
